
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Inventory, InventoryBin, InventoryBinMapping, InventoryUiClient } from '../../../../../backend/backendapi';
import { handleError, initClient } from '../../../../../../api';
import CenterOnParent from '../../../../../util/CenterOnParent';
import Spinner from '../../../../../util/Spinner';

@Component({
  components: { Spinner, CenterOnParent },
})
export default class BinEntry extends Vue {
  @Prop({ required: true })
  readonly inventory!: Inventory;
  @Prop({ required: true })
  readonly bin!: InventoryBin;
  @Prop({ required: true })
  readonly mapping!: InventoryBinMapping;

  readonly api = initClient(InventoryUiClient);
  saving = false;

  async unlink(): Promise<void> {
    this.saving = true;
    try {
      const mapping = this.mapping;
      const inventory = this.inventory;

      await this.api.deleteBinMapping(mapping.id);

      const index = inventory.bins!.findIndex(e => e.id === mapping.id);
      if (index >= 0) {
        inventory.bins!.splice(index);
      }

      this.$toasted.info(this.$t('inventory.bin.mapping.deleted').toString());
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    } finally {
      this.saving = false;
    }
  }
}
